import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
// Below mentioned imports are optional based on fireStore usage
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDeBpHY_dBcdUaIaQCyWfm3_l8iVvPI5qw",
  authDomain: "fir-notification-49ea4.firebaseapp.com",
  projectId: "fir-notification-49ea4",
  storageBucket: "fir-notification-49ea4.firebasestorage.app",
  messagingSenderId: "950561592153",
  appId: "1:950561592153:web:a370966cb9bfa704eab248",
  measurementId: "G-Z6SSQC0QD8" // optional
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

export const messaging = getMessaging(firebaseApp);
export { getToken, onMessage };

// Optional: Initialize FireStore services
export const auth = getAuth(firebaseApp);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);

export default firebaseApp;